<div class="row align-items-center p-b-10">
  <div class="col-sm-12 col-lg-6">

    <div class="d-flex align-items-center flexmob">

      <div class="d-flex align-items-center f-s-14 text-black-25 m-l-10 border-right p-x-10 cursor-pointer f-w-600" [routerLink]="['/charity']">
        <i-tabler class="icon-20 m-r-4 m-t-0 anim" name="arrow-left"></i-tabler> Back to Charity Overview
      </div>
      <div class="m-l-10 d-flex">
        <div>
          <button mat-fab style="width: 50px;height: 50px;border-radius: 20%;" class="brandbglight">
            <i-tabler name="receipt-pound" class="icon-28" style="line-height: 30px !important"></i-tabler>
          </button>
        </div>
        <div class="m-l-10">
          <h4 class="headingmain f-s-20 f-w-800 m-t-0 m-r-10">
            Notes to the Accounts
          </h4>
          <h5 class="f-s-14  text-black-25 m-t-5 ">
            Hope Foundation - 2023/24
          </h5>
        </div>
      </div>
    </div>
  </div>
  <div class="col-sm-12 col-lg-6  text-end">

    <div class="d-flex align-items-center justify-content-end">
      <!--<button mat-flat-button color="primary" class="bg-warning text-end" *ngIf="!editmode" (click)="edit()">
        <div class="d-flex text-black">
          <i-tabler class="icon-14 m-r-4 text-black" name="edit"></i-tabler><span class="f-s-12 text-black"> Edit Details</span>
        </div>
      </button>-->
    </div>
  </div>
</div>


<div class="container-fluid p-20 p-x-0 p-t-0" *ngIf="selectNotes">
  <mat-card class="m-t-6">
    <mat-card-content class="p-0">

      <div class="p-16 b-b-1" style="background: #d9eaf0; border-radius: 10px 10px 0px 0px;">
        <h4 class="m-t-10 f-s-16 f-w-600">Select Notes to Include</h4>
        <p class="f-w-500 f-s-14 text-black-50 m-0">Choose the notes that are relevant to your financial statements. Required notes are pre-selected.</p>
      </div>

      <div class="notes-list-container" style="max-height: 600px; overflow-y: scroll;">
        <div class="container-fluid p-24">
          <div class="row m-t-0">
            <div class="col-lg-4">
              <div class="theme-border b-1 p-x-10 p-y-8 rounded">
                <div class="d-flex align-items-center">
                  <mat-checkbox color="warning" class="primary-check text-right f-w-600" checked [disabled]="true"></mat-checkbox>
                  <div class="d-flex align-items-center w-100 justify-content-between">
                    <mat-label class="f-s-14 f-w-600 d-block  heading">
                      Note 1: <span class="f-w-400">Basis of preparation</span>
                    </mat-label>
                    <mat-hint class="rounded cust-danger p-4 p-x-12 f-s-12 f-w-600"> Required</mat-hint>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="theme-border b-1 p-x-10 p-y-8 rounded">
                <div class="d-flex align-items-center">
                  <mat-checkbox color="warning" class="primary-check text-right f-w-600" checked [disabled]="true"></mat-checkbox>
                  <div class="d-flex align-items-center w-100 justify-content-between">
                    <mat-label class="f-s-14 f-w-600 d-block  heading">
                      Note 2: <span class="f-w-400">Accounting policies</span>
                    </mat-label>
                    <mat-hint class="rounded cust-danger p-4 p-x-12 f-s-12 f-w-600"> Required</mat-hint>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="b-1 p-x-10 p-y-8 rounded" [ngClass]="isChecked ? 'theme-border' : '' ">
                <div class="checkbox-container" style="background: none;" (click)="isChecked = !isChecked">
                  <i-tabler class="icon-22 custom-checkbox-icon"
                            [name]="isChecked ? 'checks' : 'circle'"
                            [style.color]="isChecked ? '#6ca7c5' : '#d5d5d5'">
                  </i-tabler>
                  <div class="text-content">
                    <mat-label class="f-s-14 f-w-600 d-block heading">
                      Note 3: <span class="f-w-400">Income Analysis by Category</span>
                    </mat-label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row m-t-10">
            <div class="col-lg-4">
              <div class="b-1 p-x-10 p-y-8 rounded" [ngClass]="isChecked2 ? 'theme-border' : '' ">
                <!--<mat-checkbox color="warning" class="text-right f-w-600">
                  <div class="d-flex align-items-start">
                    <div class="text-left">
                      <mat-label class="f-s-14 f-w-600 d-block  heading">
                        Note 4: Expenditure
                      </mat-label>
                      <mat-hint class="f-s-12"> Expenditure</mat-hint>
                    </div>
                  </div>
                </mat-checkbox>-->
                <div class="checkbox-container" style="background: none;" (click)="isChecked2 = !isChecked2">
                  <i-tabler class="icon-22 custom-checkbox-icon"
                            [name]="isChecked2 ? 'checks' : 'circle'"
                            [style.color]="isChecked2 ? '#6ca7c5' : '#d5d5d5'">
                  </i-tabler>
                  <div class="text-content">
                    <mat-label class="f-s-14 f-w-600 d-block heading">
                      Note 4: <span class="f-w-400">Government Grants</span>
                    </mat-label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="b-1 p-x-10 p-y-8 rounded" [ngClass]="isChecked3 ? 'theme-border' : '' ">
                <!--<mat-checkbox color="warning" class="text-right f-w-600">
                  <div class="d-flex align-items-start">
                    <div class="text-left">
                      <mat-label class="f-s-14 f-w-600 d-block  heading">
                        Note 5: Tangible fixed assets
                      </mat-label>
                      <mat-hint class="f-s-12">  Fixed Assets</mat-hint>
                    </div>
                  </div>
                </mat-checkbox>-->
                <div class="checkbox-container" style="background: none;" (click)="isChecked3 = !isChecked3">
                  <i-tabler class="icon-22 custom-checkbox-icon"
                            [name]="isChecked3 ? 'checks' : 'circle'"
                            [style.color]="isChecked3 ? '#6ca7c5' : '#d5d5d5'">
                  </i-tabler>
                  <div class="text-content">
                    <mat-label class="f-s-14 f-w-600 d-block heading">
                      Note 5: <span class="f-w-400">Donated Goods/Services</span>
                    </mat-label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="b-1 p-x-10 p-y-8 rounded" [ngClass]="isChecked4 ? 'theme-border' : '' ">
                <!--<mat-checkbox color="warning" class="text-right f-w-600">
                  <div class="d-flex align-items-start">
                    <div class="text-left">
                      <mat-label class="f-s-14 f-w-600 d-block  heading">
                        Note 6: Investments
                      </mat-label>
                      <mat-hint class="f-s-12">  Investments</mat-hint>
                    </div>
                  </div>
                </mat-checkbox>-->
                <div class="checkbox-container" style="background: none;" (click)="isChecked4 = !isChecked4">
                  <i-tabler class="icon-22 custom-checkbox-icon"
                            [name]="isChecked4 ? 'checks' : 'circle'"
                            [style.color]="isChecked4 ? '#6ca7c5' : '#d5d5d5'">
                  </i-tabler>
                  <div class="text-content">
                    <mat-label class="f-s-14 f-w-600 d-block heading">
                      Note 6: <span class="f-w-400">Expenditure Analysis</span>
                    </mat-label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row m-t-10">
            <div class="col-lg-4">
              <div class="b-1 p-x-10 p-y-8 rounded" [ngClass]="isChecked5 ? 'theme-border' : '' ">
                <!--<mat-checkbox color="warning" class="text-right f-w-600">
                  <div class="d-flex align-items-start">
                    <div class="text-left">
                      <mat-label class="f-s-14 f-w-600 d-block  heading">
                        Note 7: Debtors
                      </mat-label>
                      <mat-hint class="f-s-12">  Current Assets</mat-hint>
                    </div>
                  </div>
                </mat-checkbox>-->
                <div class="checkbox-container" style="background: none;" (click)="isChecked5 = !isChecked5">
                  <i-tabler class="icon-22 custom-checkbox-icon"
                            [name]="isChecked5 ? 'checks' : 'circle'"
                            [style.color]="isChecked5 ? '#6ca7c5' : '#d5d5d5'">
                  </i-tabler>
                  <div class="text-content">
                    <mat-label class="f-s-14 f-w-600 d-block heading">
                      Note 7: <span class="f-w-400">Extraordinary Items</span>
                    </mat-label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="b-1 p-x-10 p-y-8 rounded" [ngClass]="isChecked6 ? 'theme-border' : '' ">
                <!--<mat-checkbox color="warning" class="text-right f-w-600">
                  <div class="d-flex align-items-start">
                    <div class="text-left">
                      <mat-label class="f-s-14 f-w-600 d-block  heading">
                        Note 8: Cash at bank and in hand
                      </mat-label>
                      <mat-hint class="f-s-12">  Current Assets</mat-hint>
                    </div>
                  </div>
                </mat-checkbox>-->
                <div class="checkbox-container" style="background: none;" (click)="isChecked6 = !isChecked6">
                  <i-tabler class="icon-22 custom-checkbox-icon"
                            [name]="isChecked6 ? 'checks' : 'circle'"
                            [style.color]="isChecked6 ? '#6ca7c5' : '#d5d5d5'">
                  </i-tabler>
                  <div class="text-content">
                    <mat-label class="f-s-14 f-w-600 d-block heading">
                      Note 8: <span class="f-w-400">Acting as Agent</span>
                    </mat-label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="b-1 p-x-10 p-y-8 rounded" [ngClass]="isChecked7 ? 'theme-border' : '' ">
                <!--<mat-checkbox color="warning" class="text-right f-w-600">
                  <div class="d-flex align-items-start">
                    <div class="text-left">
                      <mat-label class="f-s-14 f-w-600 d-block  heading">
                        Note 9: Creditors
                      </mat-label>
                      <mat-hint class="f-s-12">  Liabilities</mat-hint>
                    </div>
                  </div>
                </mat-checkbox>-->
                <div class="checkbox-container" style="background: none;" (click)="isChecked7 = !isChecked7">
                  <i-tabler class="icon-22 custom-checkbox-icon"
                            [name]="isChecked7 ? 'checks' : 'circle'"
                            [style.color]="isChecked7 ? '#6ca7c5' : '#d5d5d5'">
                  </i-tabler>
                  <div class="text-content">
                    <mat-label class="f-s-14 f-w-600 d-block heading">
                      Note 9: <span class="f-w-400">Support Costs Allocation</span>
                    </mat-label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row m-t-10">
            <div class="col-lg-4">
              <div class="b-1 p-x-10 p-y-8 rounded" [ngClass]="isChecked8 ? 'theme-border' : '' ">
                <!--<mat-checkbox color="warning" class="text-right f-w-600">
                  <div class="d-flex align-items-start">
                    <div class="text-left">
                      <mat-label class="f-s-14 f-w-600 d-block  heading">
                        Note 10: Financial instruments
                      </mat-label>
                      <mat-hint class="f-s-12">  Financial Instruments</mat-hint>
                    </div>
                  </div>
                </mat-checkbox>-->
                <div class="checkbox-container" style="background: none;" (click)="isChecked8 = !isChecked8">
                  <i-tabler class="icon-22 custom-checkbox-icon"
                            [name]="isChecked8 ? 'checks' : 'circle'"
                            [style.color]="isChecked8 ? '#6ca7c5' : '#d5d5d5'">
                  </i-tabler>
                  <div class="text-content">
                    <mat-label class="f-s-14 f-w-600 d-block heading">
                      Note 10: <span class="f-w-400">Independent Examiner/Audit Fees</span>
                    </mat-label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="b-1 p-x-10 p-y-8 rounded" [ngClass]="isChecked8 ? 'theme-border' : '' ">
                <div class="checkbox-container" style="background: none;" (click)="isChecked8 = !isChecked8">
                  <i-tabler class="icon-22 custom-checkbox-icon"
                            [name]="isChecked8 ? 'checks' : 'circle'"
                            [style.color]="isChecked8 ? '#6ca7c5' : '#d5d5d5'">
                  </i-tabler>
                  <div class="text-content">
                    <mat-label class="f-s-14 f-w-600 d-block heading">
                      Note 11: <span class="f-w-400">Staff Costs & Employee Information</span>
                    </mat-label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="b-1 p-x-10 p-y-8 rounded" [ngClass]="isChecked8 ? 'theme-border' : '' ">
                <div class="checkbox-container" style="background: none;" (click)="isChecked8 = !isChecked8">
                  <i-tabler class="icon-22 custom-checkbox-icon"
                            [name]="isChecked8 ? 'checks' : 'circle'"
                            [style.color]="isChecked8 ? '#6ca7c5' : '#d5d5d5'">
                  </i-tabler>
                  <div class="text-content">
                    <mat-label class="f-s-14 f-w-600 d-block heading">
                      Note 12: <span class="f-w-400">Pension Disclosures</span>
                    </mat-label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row m-t-10">
            <div class="col-lg-4">
              <div class="b-1 p-x-10 p-y-8 rounded" [ngClass]="isChecked8 ? 'theme-border' : '' ">
                <div class="checkbox-container" style="background: none;" (click)="isChecked8 = !isChecked8">
                  <i-tabler class="icon-22 custom-checkbox-icon"
                            [name]="isChecked8 ? 'checks' : 'circle'"
                            [style.color]="isChecked8 ? '#6ca7c5' : '#d5d5d5'">
                  </i-tabler>
                  <div class="text-content">
                    <mat-label class="f-s-14 f-w-600 d-block heading">
                      Note 13: <span class="f-w-400">Grantmaking Details</span>
                    </mat-label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="b-1 p-x-10 p-y-8 rounded" [ngClass]="isChecked8 ? 'theme-border' : '' ">
                <div class="checkbox-container" style="background: none;" (click)="isChecked8 = !isChecked8">
                  <i-tabler class="icon-22 custom-checkbox-icon"
                            [name]="isChecked8 ? 'checks' : 'circle'"
                            [style.color]="isChecked8 ? '#6ca7c5' : '#d5d5d5'">
                  </i-tabler>
                  <div class="text-content">
                    <mat-label class="f-s-14 f-w-600 d-block heading">
                      Note 14: <span class="f-w-400">Tangible Fixed Assets</span>
                    </mat-label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="b-1 p-x-10 p-y-8 rounded" [ngClass]="isChecked8 ? 'theme-border' : '' ">
                <div class="checkbox-container" style="background: none;" (click)="isChecked8 = !isChecked8">
                  <i-tabler class="icon-22 custom-checkbox-icon"
                            [name]="isChecked8 ? 'checks' : 'circle'"
                            [style.color]="isChecked8 ? '#6ca7c5' : '#d5d5d5'">
                  </i-tabler>
                  <div class="text-content">
                    <mat-label class="f-s-14 f-w-600 d-block heading">
                      Note 15: <span class="f-w-400">Intangible Assets</span>
                    </mat-label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row m-t-10">
            <div class="col-lg-4">
              <div class="b-1 p-x-10 p-y-8 rounded" [ngClass]="isChecked8 ? 'theme-border' : '' ">
                <div class="checkbox-container" style="background: none;" (click)="isChecked8 = !isChecked8">
                  <i-tabler class="icon-22 custom-checkbox-icon"
                            [name]="isChecked8 ? 'checks' : 'circle'"
                            [style.color]="isChecked8 ? '#6ca7c5' : '#d5d5d5'">
                  </i-tabler>
                  <div class="text-content">
                    <mat-label class="f-s-14 f-w-600 d-block heading">
                      Note 16: <span class="f-w-400">Heritage Assets</span>
                    </mat-label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="b-1 p-x-10 p-y-8 rounded" [ngClass]="isChecked8 ? 'theme-border' : '' ">
                <div class="checkbox-container" style="background: none;" (click)="isChecked8 = !isChecked8">
                  <i-tabler class="icon-22 custom-checkbox-icon"
                            [name]="isChecked8 ? 'checks' : 'circle'"
                            [style.color]="isChecked8 ? '#6ca7c5' : '#d5d5d5'">
                  </i-tabler>
                  <div class="text-content">
                    <mat-label class="f-s-14 f-w-600 d-block heading">
                      Note 17: <span class="f-w-400">Investment Assets</span>
                    </mat-label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="b-1 p-x-10 p-y-8 rounded" [ngClass]="isChecked8 ? 'theme-border' : '' ">
                <div class="checkbox-container" style="background: none;" (click)="isChecked8 = !isChecked8">
                  <i-tabler class="icon-22 custom-checkbox-icon"
                            [name]="isChecked8 ? 'checks' : 'circle'"
                            [style.color]="isChecked8 ? '#6ca7c5' : '#d5d5d5'">
                  </i-tabler>
                  <div class="text-content">
                    <mat-label class="f-s-14 f-w-600 d-block heading">
                      Note 18: <span class="f-w-400">Stocks</span>
                    </mat-label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row m-t-10">
            <div class="col-lg-4">
              <div class="b-1 p-x-10 p-y-8 rounded" [ngClass]="isChecked8 ? 'theme-border' : '' ">
                <div class="checkbox-container" style="background: none;" (click)="isChecked8 = !isChecked8">
                  <i-tabler class="icon-22 custom-checkbox-icon"
                            [name]="isChecked8 ? 'checks' : 'circle'"
                            [style.color]="isChecked8 ? '#6ca7c5' : '#d5d5d5'">
                  </i-tabler>
                  <div class="text-content">
                    <mat-label class="f-s-14 f-w-600 d-block heading">
                      Note 19: <span class="f-w-400">Debtors & Prepayments</span>
                    </mat-label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="b-1 p-x-10 p-y-8 rounded" [ngClass]="isChecked8 ? 'theme-border' : '' ">
                <div class="checkbox-container" style="background: none;" (click)="isChecked8 = !isChecked8">
                  <i-tabler class="icon-22 custom-checkbox-icon"
                            [name]="isChecked8 ? 'checks' : 'circle'"
                            [style.color]="isChecked8 ? '#6ca7c5' : '#d5d5d5'">
                  </i-tabler>
                  <div class="text-content">
                    <mat-label class="f-s-14 f-w-600 d-block heading">
                      Note 20: <span class="f-w-400">Creditors & Accruals</span>
                    </mat-label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="b-1 p-x-10 p-y-8 rounded" [ngClass]="isChecked8 ? 'theme-border' : '' ">
                <div class="checkbox-container" style="background: none;" (click)="isChecked8 = !isChecked8">
                  <i-tabler class="icon-22 custom-checkbox-icon"
                            [name]="isChecked8 ? 'checks' : 'circle'"
                            [style.color]="isChecked8 ? '#6ca7c5' : '#d5d5d5'">
                  </i-tabler>
                  <div class="text-content">
                    <mat-label class="f-s-14 f-w-600 d-block heading">
                      Note 21: <span class="f-w-400">Provisions & Contingent Liabilities</span>
                    </mat-label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row m-t-10">
            <div class="col-lg-4">
              <div class="b-1 p-x-10 p-y-8 rounded" [ngClass]="isChecked8 ? 'theme-border' : '' ">
                <div class="checkbox-container" style="background: none;" (click)="isChecked8 = !isChecked8">
                  <i-tabler class="icon-22 custom-checkbox-icon"
                            [name]="isChecked8 ? 'checks' : 'circle'"
                            [style.color]="isChecked8 ? '#6ca7c5' : '#d5d5d5'">
                  </i-tabler>
                  <div class="text-content">
                    <mat-label class="f-s-14 f-w-600 d-block heading">
                      Note 22: <span class="f-w-400">Financial Instruments</span>
                    </mat-label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="b-1 p-x-10 p-y-8 rounded" [ngClass]="isChecked8 ? 'theme-border' : '' ">
                <div class="checkbox-container" style="background: none;" (click)="isChecked8 = !isChecked8">
                  <i-tabler class="icon-22 custom-checkbox-icon"
                            [name]="isChecked8 ? 'checks' : 'circle'"
                            [style.color]="isChecked8 ? '#6ca7c5' : '#d5d5d5'">
                  </i-tabler>
                  <div class="text-content">
                    <mat-label class="f-s-14 f-w-600 d-block heading">
                      Note 23: <span class="f-w-400">Contingent Assets & Liabilities</span>
                    </mat-label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="b-1 p-x-10 p-y-8 rounded" [ngClass]="isChecked8 ? 'theme-border' : '' ">
                <div class="checkbox-container" style="background: none;" (click)="isChecked8 = !isChecked8">
                  <i-tabler class="icon-22 custom-checkbox-icon"
                            [name]="isChecked8 ? 'checks' : 'circle'"
                            [style.color]="isChecked8 ? '#6ca7c5' : '#d5d5d5'">
                  </i-tabler>
                  <div class="text-content">
                    <mat-label class="f-s-14 f-w-600 d-block heading">
                      Note 24: <span class="f-w-400">Cash at Bank and in Hand</span>
                    </mat-label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row m-t-10">
            <div class="col-lg-4">
              <div class="b-1 p-x-10 p-y-8 rounded" [ngClass]="isChecked8 ? 'theme-border' : '' ">
                <div class="checkbox-container" style="background: none;" (click)="isChecked8 = !isChecked8">
                  <i-tabler class="icon-22 custom-checkbox-icon"
                            [name]="isChecked8 ? 'checks' : 'circle'"
                            [style.color]="isChecked8 ? '#6ca7c5' : '#d5d5d5'">
                  </i-tabler>
                  <div class="text-content">
                    <mat-label class="f-s-14 f-w-600 d-block heading">
                      Note 25: <span class="f-w-400">Fair Value Disclosures</span>
                    </mat-label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="b-1 p-x-10 p-y-8 rounded" [ngClass]="isChecked8 ? 'theme-border' : '' ">
                <div class="checkbox-container" style="background: none;" (click)="isChecked8 = !isChecked8">
                  <i-tabler class="icon-22 custom-checkbox-icon"
                            [name]="isChecked8 ? 'checks' : 'circle'"
                            [style.color]="isChecked8 ? '#6ca7c5' : '#d5d5d5'">
                  </i-tabler>
                  <div class="text-content">
                    <mat-label class="f-s-14 f-w-600 d-block heading">
                      Note 26: <span class="f-w-400">Post-Balance Sheet Events</span>
                    </mat-label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="b-1 p-x-10 p-y-8 rounded" [ngClass]="isChecked8 ? 'theme-border' : '' ">
                <div class="checkbox-container" style="background: none;" (click)="isChecked8 = !isChecked8">
                  <i-tabler class="icon-22 custom-checkbox-icon"
                            [name]="isChecked8 ? 'checks' : 'circle'"
                            [style.color]="isChecked8 ? '#6ca7c5' : '#d5d5d5'">
                  </i-tabler>
                  <div class="text-content">
                    <mat-label class="f-s-14 f-w-600 d-block heading">
                      Note 27: <span class="f-w-400">Fund Movements & Reconciliation</span>
                    </mat-label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row m-t-10">
            <div class="col-lg-4">
              <div class="b-1 p-x-10 p-y-8 rounded" [ngClass]="isChecked8 ? 'theme-border' : '' ">
                <div class="checkbox-container" style="background: none;" (click)="isChecked8 = !isChecked8">
                  <i-tabler class="icon-22 custom-checkbox-icon"
                            [name]="isChecked8 ? 'checks' : 'circle'"
                            [style.color]="isChecked8 ? '#6ca7c5' : '#d5d5d5'">
                  </i-tabler>
                  <div class="text-content">
                    <mat-label class="f-s-14 f-w-600 d-block heading">
                      Note 28: <span class="f-w-400">Trustee & Related Party Transactions</span>
                    </mat-label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="b-1 p-x-10 p-y-8 rounded" [ngClass]="isChecked8 ? 'theme-border' : '' ">
                <div class="checkbox-container" style="background: none;" (click)="isChecked8 = !isChecked8">
                  <i-tabler class="icon-22 custom-checkbox-icon"
                            [name]="isChecked8 ? 'checks' : 'circle'"
                            [style.color]="isChecked8 ? '#6ca7c5' : '#d5d5d5'">
                  </i-tabler>
                  <div class="text-content">
                    <mat-label class="f-s-14 f-w-600 d-block heading">
                      Note 29: <span class="f-w-400">Other Disclosures (custom/free-form)</span>
                    </mat-label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid">
        <div class="row b-t-1 p-t-24 p-b-20 p-x-30">
          <div class="col-6 text-right d-flex align-items-center justify-content-between">
            <div class="col-lg-4 text-left">
              <mat-label class="f-s-14 f-w-600 m-b-8 d-block">Jump to next section</mat-label>
            </div>
            <div class="col-lg-8">
              <mat-form-field appearance="outline" class="w-100">
                <mat-select value="notes" placeholder="Select Notes Section" formControlName="">
                  <mat-option value="">Select Notes Section</mat-option>
                  <mat-option value="female">Other</mat-option>
                  <mat-option value="other">Other</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="col-6 text-right">
            <button mat-flat-button color="primary" (click)="continueSelectedNotes()">
              <div class="d-flex align-items-center">
                <i-tabler class="icon-18 m-r-10" name="circle-check"></i-tabler> Continue with Selected Notes (2)
              </div>
            </button>
          </div>
        </div>
      </div>

    </mat-card-content>
  </mat-card>
</div>
<div class="p-0" *ngIf="selectedNotes">
  <div class="m-t-20" [formGroup]="Addnotes2form">
    <div class="row">
      <div class="col-lg-3 cust-width-col-lg-3">
        <mat-card>
          <mat-card-content class="p-0">
            <div class="p-16 b-b-1" style="background: #d9eaf0; border-radius: 10px 10px 0px 0px;">
              <h4 class="m-t-10 f-s-16 f-w-600">Selected Notes</h4>
              <p class="f-w-500 f-s-14 text-black-50 m-0">4 notes selected</p>
            </div>

            <mat-list class="m-x-10 m-r-2 p-r-6" style="max-height: 780px; overflow-y: auto;">
              <h4 class="f-s-14 f-w-600 m-b-10 notes-title-card">Note 1: General Information</h4>
              <mat-list-item class="position-relative" [ngClass]="isActive1 ? 'active-tab' : ''" (click)="ClickSelectedNote('isActive1','note1')">
                <span matListItemTitle class="f-s-14 f-w-400"> General Information</span>
                <span class="status-dot position-absolute"></span>
              </mat-list-item>

              <h4 class="f-s-14 f-w-600 m-b-10 m-t-10 notes-title-card">Note 2: Accounting Policies</h4>
              <mat-list-item class="position-relative" [ngClass]="isActive2 ? 'active-tab' : ''" (click)="ClickSelectedNote('isActive2','note2')">
                <span matListItemTitle class="f-s-14 f-w-400"> Basis of Preparation</span>
                <span class="status-dot position-absolute"></span>
              </mat-list-item>
              <mat-list-item class="position-relative" [ngClass]="isActive3 ? 'active-tab' : ''" (click)="ClickSelectedNote('isActive3','note3')">
                <span matListItemTitle class="f-s-14 f-w-400"> Going Concern</span>
                <span class="status-dot position-absolute"></span>
              </mat-list-item>
              <mat-list-item class="position-relative" [ngClass]="isActive4 ? 'active-tab' : ''" (click)="ClickSelectedNote('isActive4','note4')">
                <span matListItemTitle class="f-s-14 f-w-400"> Change of Accounting Policy</span>
                <!--<span class="status-dot position-absolute"></span>-->
              </mat-list-item>
              <mat-list-item class="position-relative" [ngClass]="isActive5 ? 'active-tab' : ''" (click)="ClickSelectedNote('isActive5','note5')">
                <span matListItemTitle class="f-s-14 f-w-400"> Changes to Accounting Estimates</span>
                <!--<span class="status-dot position-absolute"></span>-->
              </mat-list-item>
              <mat-list-item class="position-relative" [ngClass]="isActive6 ? 'active-tab' : ''" (click)="ClickSelectedNote('isActive6','note6')">
                <span matListItemTitle class="f-s-14 f-w-400"> Material Prior year Errors</span>
                <!--<span class="status-dot position-absolute"></span>-->
              </mat-list-item>
              <mat-list-item class="position-relative" [ngClass]="isActive7 ? 'active-tab' : ''" (click)="ClickSelectedNote('isActive7','note7')">
                <span matListItemTitle class="f-s-14 f-w-400"> Reconciliation with Previous Generally <br>Accepted Accounting Practice</span>
                <!--<span class="status-dot position-absolute"></span>-->
              </mat-list-item>
              <mat-list-item class="position-relative" [ngClass]="isActive8 ? 'active-tab' : ''" (click)="ClickSelectedNote('isActive8','note8')">
                <span matListItemTitle class="f-s-14 f-w-400"> Income </span>
                <!--<span class="status-dot position-absolute"></span>-->
              </mat-list-item>
              <mat-list-item class="position-relative" [ngClass]="isActive9 ? 'active-tab' : ''" (click)="ClickSelectedNote('isActive9','note9')">
                <span matListItemTitle class="f-s-14 f-w-400"> Expenditure and Liabilities </span>
                <!--<span class="status-dot position-absolute"></span>-->
              </mat-list-item>
              <mat-list-item class="position-relative m-b-10" [ngClass]="isActive10 ? 'active-tab' : ''" (click)="ClickSelectedNote('isActive10','note10')">
                <span matListItemTitle class="f-s-14 f-w-400"> Assets </span>
                <!--<span class="status-dot position-absolute"></span>-->
              </mat-list-item>
              <h4 class="f-s-14 f-w-600 m-b-10 notes-title-card">Note 3: Analysis of Income</h4>
              <mat-list-item class="position-relative" [ngClass]="isActive11 ? 'active-tab' : ''" (click)="changetoNoteTab11()">
                <span matListItemTitle class="f-s-14 f-w-400"> Donations and Legacies </span>
                <!--<span class="status-dot position-absolute"></span>-->
              </mat-list-item>
              <mat-list-item class="position-relative" [ngClass]="isActive12 ? 'active-tab' : ''" (click)="changetoNoteTab12()">
                <span matListItemTitle class="f-s-14 f-w-400"> Charitable Activities </span>
                <!--<span class="status-dot position-absolute"></span>-->
              </mat-list-item>
              <mat-list-item class="position-relative" [ngClass]="isActive13 ? 'active-tab' : ''" (click)="changetoNoteTab13()">
                <span matListItemTitle class="f-s-14 f-w-400"> Other Trading Activities </span>
                <!--<span class="status-dot position-absolute"></span>-->
              </mat-list-item>
              <mat-list-item class="position-relative" [ngClass]="isActive14 ? 'active-tab' : ''" (click)="changetoNoteTab14()">
                <span matListItemTitle class="f-s-14 f-w-400"> Investment Income </span>
                <!--<span class="status-dot position-absolute"></span>-->
              </mat-list-item>
              <mat-list-item class="position-relative m-b-10" [ngClass]="isActive15 ? 'active-tab' : ''" (click)="changetoNoteTab15()">
                <span matListItemTitle class="f-s-14 f-w-400"> Separate Material Item of Income </span>
                <!--<span class="status-dot position-absolute"></span>-->
              </mat-list-item>
              <mat-list-item class="position-relative m-b-10" [ngClass]="isActive16 ? 'active-tab' : ''" (click)="changetoNoteTab16()">
                <span matListItemTitle class="f-s-14 f-w-400"> Other Trading Activities </span>
                <!--<span class="status-dot position-absolute"></span>-->
              </mat-list-item>
              <mat-list-item class="position-relative m-b-10" [ngClass]="isActive17 ? 'active-tab' : ''" (click)="changetoNoteTab17()">
                <span matListItemTitle class="f-s-14 f-w-400"> Other Informations </span>
                <!--<span class="status-dot position-absolute"></span>-->
              </mat-list-item>
              <h4 class="f-s-14 f-w-600 m-b-10 notes-title-card">Note 4: Analysis of Receipts of Government Grants</h4>
              <mat-list-item class="position-relative m-b-10" [ngClass]="isActive18 ? 'active-tab' : ''" (click)="ClickSelectedNote('isActive18','note18')">
                <span matListItemTitle class="f-s-14 f-w-400"> Analysis of Receipts of Government Grants </span>
                <!--<span class="status-dot position-absolute"></span>-->
              </mat-list-item>
              <h4 class="f-s-14 f-w-600 m-b-10 notes-title-card">Note 5: Donated goods, facilities and services</h4>
              <mat-list-item class="position-relative m-b-10" [ngClass]="isActive19 ? 'active-tab' : ''" (click)="ClickSelectedNote('isActive19','note19')">
                <span matListItemTitle class="f-s-14 f-w-400"> Donated Goods, Facilities and Services </span>
                <!--<span class="status-dot position-absolute"></span>-->
              </mat-list-item>
              <h4 class="f-s-14 f-w-600 m-b-10 notes-title-card">Note 6: Expenditure Analysis</h4>
              <mat-list-item class="position-relative" [ngClass]="isActive20 ? 'active-tab' : ''" (click)="ClickSelectedNote('isActive20','note20')">
                <span matListItemTitle class="f-s-14 f-w-400"> Expenditure on Raising Funds </span>
                <!--<span class="status-dot position-absolute"></span>-->
              </mat-list-item>
              <mat-list-item class="position-relative" [ngClass]="isActive21 ? 'active-tab' : ''" (click)="ClickSelectedNote('isActive21','note21')">
                <span matListItemTitle class="f-s-14 f-w-400"> Expenditure on Charitable Activities </span>
                <!--<span class="status-dot position-absolute"></span>-->
              </mat-list-item>
              <mat-list-item class="position-relative" [ngClass]="isActive22 ? 'active-tab' : ''" (click)="ClickSelectedNote('isActive22','note22')">
                <span matListItemTitle class="f-s-14 f-w-400"> Separate Material Item of Expense </span>
                <!--<span class="status-dot position-absolute"></span>-->
              </mat-list-item>
              <mat-list-item class="position-relative m-b-10" [ngClass]="isActive23 ? 'active-tab' : ''" (click)="ClickSelectedNote('isActive23','note23')">
                <span matListItemTitle class="f-s-14 f-w-400"> Other Expenditure</span>
                <!--<span class="status-dot position-absolute"></span>-->
              </mat-list-item>
              <h4 class="f-s-14 f-w-600 m-b-10 notes-title-card">Note 7: Extraordinary Items</h4>
              <mat-list-item class="position-relative" [ngClass]="isActive24 ? 'active-tab' : ''" (click)="ClickSelectedNote('isActive24','note24')">
                <span matListItemTitle class="f-s-14 f-w-400"> Analysis of Extraordinary Items </span>
                <!--<span class="status-dot position-absolute"></span>-->
              </mat-list-item>
              <h4 class="f-s-14 f-w-600 m-b-10 notes-title-card">Note 8: Funds received as agent</h4>
              <mat-list-item class="position-relative" [ngClass]="isActive25 ? 'active-tab' : ''" (click)="ClickSelectedNote('isActive25','note25')">
                <span matListItemTitle class="f-s-14 f-w-400"> Agent Funds Administration </span>
                <!--<span class="status-dot position-absolute"></span>-->
              </mat-list-item>
              <mat-list-item class="position-relative" [ngClass]="isActive26 ? 'active-tab' : ''" (click)="ClickSelectedNote('isActive26','note26')">
                <span matListItemTitle class="f-s-14 f-w-400"> Consortia Arrangements </span>
                <!--<span class="status-dot position-absolute"></span>-->
              </mat-list-item>
              <h4 class="f-s-14 f-w-600 m-b-10 notes-title-card">Note 9: Support Costs</h4>
              <mat-list-item class="position-relative" [ngClass]="isActive27 ? 'active-tab' : ''" (click)="ClickSelectedNote('isActive27','note27')">
                <span matListItemTitle class="f-s-14 f-w-400"> Support Costs </span>
                <!--<span class="status-dot position-absolute"></span>-->
              </mat-list-item>
              <h4 class="f-s-14 f-w-600 m-b-10 notes-title-card">Note 10: Details of certain types of expenditure</h4>
              <mat-list-item class="position-relative" [ngClass]="isActive28 ? 'active-tab' : ''" (click)="ClickSelectedNote('isActive28','note28')">
                <span matListItemTitle class="f-s-14 f-w-400"> Fees for examination of the accounts </span>
                <!--<span class="status-dot position-absolute"></span>-->
              </mat-list-item>
              <h4 class="f-s-14 f-w-600 m-b-10 notes-title-card">Note 11: Paid employees</h4>
              <mat-list-item class="position-relative" [ngClass]="isActive29 ? 'active-tab' : ''" (click)="ClickSelectedNote('isActive29','note29')">
                <span matListItemTitle class="f-s-14 f-w-400"> Staff Costs </span>
                <!--<span class="status-dot position-absolute"></span>-->
              </mat-list-item>
              <mat-list-item class="position-relative" [ngClass]="isActive30 ? 'active-tab' : ''" (click)="ClickSelectedNote('isActive30','note30')">
                <span matListItemTitle class="f-s-14 f-w-400"> Average head count in the year </span>
                <!--<span class="status-dot position-absolute"></span>-->
              </mat-list-item>
              <mat-list-item class="position-relative" [ngClass]="isActive31 ? 'active-tab' : ''" (click)="ClickSelectedNote('isActive31','note31')">
                <span matListItemTitle class="f-s-14 f-w-400"> Ex-gratia payments to employees and others (excluding trustees) </span>
                <!--<span class="status-dot position-absolute"></span>-->
              </mat-list-item>
              <mat-list-item class="position-relative" [ngClass]="isActive32 ? 'active-tab' : ''" (click)="ClickSelectedNote('isActive32','note32')">
                <span matListItemTitle class="f-s-14 f-w-400"> Redundancy payments </span>
                <!--<span class="status-dot position-absolute"></span>-->
              </mat-list-item>
              <h4 class="f-s-14 f-w-600 m-b-10 notes-title-card">Note 12: Pension Schemes</h4>
              <mat-list-item class="position-relative" [ngClass]="isActive33 ? 'active-tab' : ''" (click)="ClickSelectedNote('isActive33','note33')">
                <span matListItemTitle class="f-s-14 f-w-400"> Defined Contribution Scheme </span>
                <!--<span class="status-dot position-absolute"></span>-->
              </mat-list-item>
              <mat-list-item class="position-relative" [ngClass]="isActive34 ? 'active-tab' : ''" (click)="ClickSelectedNote('isActive34','note34')">
                <span matListItemTitle class="f-s-14 f-w-400">  Defined Benefit Plan (un-ascertainable share) </span>
                <!--<span class="status-dot position-absolute"></span>-->
              </mat-list-item>
              <mat-list-item class="position-relative" [ngClass]="isActive35 ? 'active-tab' : ''" (click)="ClickSelectedNote('isActive35','note35')">
                <span matListItemTitle class="f-s-14 f-w-400">  Multi-employer Defined Benefit Plan </span>
                <!--<span class="status-dot position-absolute"></span>-->
              </mat-list-item>
            </mat-list>

          </mat-card-content>
        </mat-card>
      </div>
      <div class="col-lg-9 cust-width-col-lg-9 p-l-0 p-r-4">
        <mat-card *ngIf="note1">
          <mat-card-content class="p-0">
            <div class="p-y-16 p-x-20 b-b-1" style="background: #d9eaf0; border-radius: 10px 10px 0px 0px;">
              <div class="d-flex justify-content-between align-items-center">
                <div class="titles">
                  <h4 class="m-t-10 f-s-16 f-w-600">Note 1: General Information</h4>
                </div>
              </div>
            </div>

            <div class="p-y-16 p-x-24">
              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    General Information
                  </h4>
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                  <textarea matInput rows="7" class="text-start" disabled formControlName="">These accounts have been prepared under the historical cost convention with items recognised at cost or transaction value unless otherwise stated in the relevant note(s) to these accounts. The accounts have been prepared in accordance with: the Statement of Recommended Practice: Accounting and Reporting by Charities preparing their accounts in accordance with the Financial Reporting Standard applicable in the UK and Republic of Ireland (FRS 102) issued on 16 July 2014 and with the Financial Reporting Standard applicable in the United Kingdom and Republic of Ireland (FRS 102) and with the Charities Act 2011. The charity constitutes a public benefit entity as defined by FRS 102.</textarea>
                </mat-form-field>
              </div>
            </div>

          </mat-card-content>
        </mat-card>
        <mat-card *ngIf="note2">
          <mat-card-content class="p-0">
            <div class="p-y-16 p-x-20 b-b-1" style="background: #d9eaf0; border-radius: 10px 10px 0px 0px;">
              <div class="d-flex justify-content-between align-items-center">
                <div class="titles">
                  <h4 class="m-t-10 f-s-16 f-w-600">Note 2: Accounting Policies</h4>
                </div>
              </div>
            </div>
            <div class="p-y-16 p-x-24">
              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Basis of Preparation
                  </h4>
                  <button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                  <textarea matInput rows="7" class="text-start" formControlName="Basis_of_Preparation">
                  </textarea>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">

                <div class="row p-16 p-t-0">

                  <div class="col-sm-12 col-md-4">
                    <button mat-flat-button color="primary" class="bg-warning text-end" (click)="backToSelectNotes()">
                      <div class="d-flex text-black">
                        <i-tabler class="icon-20 m-r-4 m-t-0 " name="arrow-left"></i-tabler><span class="f-s-12 text-black"> Back</span>
                      </div>
                    </button>
                  </div>
                  <div class="col-sm-12 col-md-8" align="right">
                    <button mat-flat-button color="primary" class="bgwhite border-light b-1 text-end m-r-10">
                      <div class="d-flex text-black">
                        <i-tabler class="icon-20 m-r-4 m-t-0 text-dark" name="device-floppy"></i-tabler><span class="f-s-14 text-dark"> Save as Draft</span>
                      </div>
                    </button>
                    <button mat-flat-button color="primary" class="bg-success rounded-5" (click)="SaveAndNext()">
                      <div class="d-flex text-black">
                        <i-tabler class="icon-20 m-r-4 m-t-0 text-white" name="arrow-right"></i-tabler><span class="f-s-14 text-white"> Save &amp; Next</span>
                      </div>
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card *ngIf="note3">
          <mat-card-content class="p-0">
            <div class="p-y-16 p-x-20 b-b-1" style="background: #d9eaf0; border-radius: 10px 10px 0px 0px;">
              <div class="d-flex justify-content-between align-items-center">
                <div class="titles">
                  <h4 class="m-t-10 f-s-16 f-w-600">Note 2: Accounting Policies</h4>
                </div>
              </div>
            </div>
            <div class="p-y-16 p-x-24">
              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Going concern
                  </h4>
                  <button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                  <textarea matInput rows="6" class="text-start" formControlName="Going_concern"></textarea>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">

                <div class="row p-16 p-t-0">

                  <div class="col-sm-12 col-md-4">
                    <button mat-flat-button color="primary" class="bg-warning text-end" (click)="backToSelectNotes()">
                      <div class="d-flex text-black">
                        <i-tabler class="icon-20 m-r-4 m-t-0 " name="arrow-left"></i-tabler><span class="f-s-12 text-black"> Back</span>
                      </div>
                    </button>
                  </div>
                  <div class="col-sm-12 col-md-8" align="right">
                    <button mat-flat-button color="primary" class="bgwhite border-light b-1 text-end m-r-10">
                      <div class="d-flex text-black">
                        <i-tabler class="icon-20 m-r-4 m-t-0 text-dark" name="device-floppy"></i-tabler><span class="f-s-14 text-dark"> Save as Draft</span>
                      </div>
                    </button>
                    <button mat-flat-button color="primary" class="bg-success rounded-5" (click)="SaveAndNext()">
                      <div class="d-flex text-black">
                        <i-tabler class="icon-20 m-r-4 m-t-0 text-white" name="arrow-right"></i-tabler><span class="f-s-14 text-white"> Save &amp; Next</span>
                      </div>
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card *ngIf="note4">
          <mat-card-content class="p-0">
            <div class="p-y-16 p-x-20 b-b-1" style="background: #d9eaf0; border-radius: 10px 10px 0px 0px;">
              <div class="d-flex justify-content-between align-items-center">
                <div class="titles">
                  <h4 class="m-t-10 f-s-16 f-w-600">Note 2: Accounting Policies</h4>
                </div>
              </div>
            </div>
            <div class="p-y-16 p-x-24">
              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Change of accounting policy
                  </h4>
                  <!--<button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
              <span class=""> Default Statement </span>
            </button>-->
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                  <textarea matInput rows="6" class="text-start" formControlName="Changeofaccountingpolicy"></textarea>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">

                <div class="row p-16 p-t-0">

                  <div class="col-sm-12 col-md-4">
                    <button mat-flat-button color="primary" class="bg-warning text-end" (click)="backToSelectNotes()">
                      <div class="d-flex text-black">
                        <i-tabler class="icon-20 m-r-4 m-t-0 " name="arrow-left"></i-tabler><span class="f-s-12 text-black"> Back</span>
                      </div>
                    </button>
                  </div>
                  <div class="col-sm-12 col-md-8" align="right">
                    <button mat-flat-button color="primary" class="bgwhite border-light b-1 text-end m-r-10">
                      <div class="d-flex text-black">
                        <i-tabler class="icon-20 m-r-4 m-t-0 text-dark" name="device-floppy"></i-tabler><span class="f-s-14 text-dark"> Save as Draft</span>
                      </div>
                    </button>
                    <button mat-flat-button color="primary" class="bg-success rounded-5" (click)="SaveAndNext()">
                      <div class="d-flex text-black">
                        <i-tabler class="icon-20 m-r-4 m-t-0 text-white" name="arrow-right"></i-tabler><span class="f-s-14 text-white"> Save &amp; Next</span>
                      </div>
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card *ngIf="note5">
          <mat-card-content class="p-0">
            <div class="p-y-16 p-x-20 b-b-1" style="background: #d9eaf0; border-radius: 10px 10px 0px 0px;">
              <div class="d-flex justify-content-between align-items-center">
                <div class="titles">
                  <h4 class="m-t-10 f-s-16 f-w-600">Note 2: Accounting Policies</h4>
                </div>
              </div>
            </div>
            <div class="p-y-16 p-x-24">
              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Changes to accounting estimates
                  </h4>
                  <!--<button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
              <span class=""> Default Statement </span>
            </button>-->
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                  <textarea matInput rows="6" value="" class="text-start" formControlName="Changestoaccountingestimates"></textarea>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">

                <div class="row p-16 p-t-0">

                  <div class="col-sm-12 col-md-4">
                    <button mat-flat-button color="primary" class="bg-warning text-end" (click)="backToSelectNotes()">
                      <div class="d-flex text-black">
                        <i-tabler class="icon-20 m-r-4 m-t-0 " name="arrow-left"></i-tabler><span class="f-s-12 text-black"> Back</span>
                      </div>
                    </button>
                  </div>
                  <div class="col-sm-12 col-md-8" align="right">
                    <button mat-flat-button color="primary" class="bgwhite border-light b-1 text-end m-r-10">
                      <div class="d-flex text-black">
                        <i-tabler class="icon-20 m-r-4 m-t-0 text-dark" name="device-floppy"></i-tabler><span class="f-s-14 text-dark"> Save as Draft</span>
                      </div>
                    </button>
                    <button mat-flat-button color="primary" class="bg-success rounded-5" (click)="SaveAndNext()">
                      <div class="d-flex text-black">
                        <i-tabler class="icon-20 m-r-4 m-t-0 text-white" name="arrow-right"></i-tabler><span class="f-s-14 text-white"> Save &amp; Next</span>
                      </div>
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card *ngIf="note6">
          <mat-card-content class="p-0">
            <div class="p-y-16 p-x-20 b-b-1" style="background: #d9eaf0; border-radius: 10px 10px 0px 0px;">
              <div class="d-flex justify-content-between align-items-center">
                <div class="titles">
                  <h4 class="m-t-10 f-s-16 f-w-600">Note 2: Accounting Policies</h4>
                </div>
              </div>
            </div>
            <div class="p-y-16 p-x-24">
              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Material prior year errors
                  </h4>
                  <!--<button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
              <span class=""> Default Statement </span>
            </button>-->
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                  <textarea matInput rows="6" value="" class="text-start" formControlName="Materialprioryearerrors"></textarea>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">

                <div class="row p-16 p-t-0">

                  <div class="col-sm-12 col-md-4">
                    <button mat-flat-button color="primary" class="bg-warning text-end" (click)="backToSelectNotes()">
                      <div class="d-flex text-black">
                        <i-tabler class="icon-20 m-r-4 m-t-0 " name="arrow-left"></i-tabler><span class="f-s-12 text-black"> Back</span>
                      </div>
                    </button>
                  </div>
                  <div class="col-sm-12 col-md-8" align="right">
                    <button mat-flat-button color="primary" class="bgwhite border-light b-1 text-end m-r-10">
                      <div class="d-flex text-black">
                        <i-tabler class="icon-20 m-r-4 m-t-0 text-dark" name="device-floppy"></i-tabler><span class="f-s-14 text-dark"> Save as Draft</span>
                      </div>
                    </button>
                    <button mat-flat-button color="primary" class="bg-success rounded-5" (click)="SaveAndNext()">
                      <div class="d-flex text-black">
                        <i-tabler class="icon-20 m-r-4 m-t-0 text-white" name="arrow-right"></i-tabler><span class="f-s-14 text-white"> Save &amp; Next</span>
                      </div>
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card *ngIf="note7">
          <mat-card-content class="p-0">
            <div class="p-y-16 p-x-20 b-b-1" style="background: #d9eaf0; border-radius: 10px 10px 0px 0px;">
              <div class="d-flex justify-content-between align-items-center">
                <div class="titles">
                  <h4 class="m-t-10 f-s-16 f-w-600">Note 2: Accounting Policies</h4>
                </div>
              </div>
            </div>
            <div class="p-y-16 p-x-24" style="max-height: 650px; overflow-y: scroll; margin-bottom: 30px;">
              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Reconciliation with previous generally accepted accounting practice
                  </h4>
                  <button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <p class="f-s-14 p-x-10 f-w-400 m-b-0">
                  Please provide a description of the nature of each change in accounting policy
                </p>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                  <textarea matInput rows="4" value="" class="text-start" formControlName="Reconciliationaccountingpractice"></textarea>
                </mat-form-field>
              </div>

              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Reconcilation of funds per previous GAAP to funds determined under FRS 102
                  </h4>
                  <!--<button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
              <span class=""> Default Statement </span>
            </button>-->
                </div>
                <mat-card class="cardWithShadow m-t-10 m-x-10" style="border-radius: 10px;">
                  <mat-card-content class="p-0">
                    <div class="table-responsive" style="border-radius: 10px;">
                      <table mat-table [dataSource]="data" class="w-100">
                        <ng-container matColumnDef="Fund balances as previously stated">
                          <th mat-header-cell *matHeaderCellDef class="f-s-14 f-w-600">
                            Fund balances as previously stated <br> Adjustments
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left">
                            <mat-form-field appearance="outline" class="bg-white w-100" color="primary">
                              <input matInput class="text-left" formControlName="" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600">Fund balance as restated</td>
                        </ng-container>

                        <ng-container matColumnDef="Start of period">
                          <th mat-header-cell *matHeaderCellDef class="f-s-14 f-w-600 text-center">
                            Start of period <br> &pound;
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left">
                            <mat-form-field appearance="outline" class="bg-white w-100" color="primary">
                              <input matInput class="text-left" formControlName="" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600"></td>
                        </ng-container>

                        <ng-container matColumnDef="End of period">
                          <th mat-header-cell *matHeaderCellDef class="f-s-14 f-w-600 text-center">
                            End of period <br> &pound;
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left">
                            <mat-form-field appearance="outline" class="bg-white w-100" color="primary">
                              <input matInput class="text-left" formControlName="" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600"></td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                        <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>

                      </table>
                    </div>
                    <button mat-flat-button color="primary" class="m-l-20 m-b-10" style="height: 30px;">
                      <div class="d-flex align-items-center">
                        <i-tabler class="icon-18 m-r-10" name="plus"></i-tabler><span class="hidemenutext"> Add </span>
                      </div>
                    </button>
                  </mat-card-content>
                </mat-card>
              </div>

              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Reconcilation of net income/(net expenditure) per previous GAAP to net income/(net expenditure) under FRS 102
                  </h4>
                  <!--<button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
              <span class=""> Default Statement </span>
            </button>-->
                </div>
                <mat-card class="cardWithShadow m-t-10 m-x-10" style="border-radius: 10px;">
                  <mat-card-content class="p-0">
                    <div class="table-responsive" style="border-radius: 10px;">
                      <table mat-table [dataSource]="data2" class="w-100">
                        <ng-container matColumnDef="Net income/(expenditure) as previously stated">
                          <th mat-header-cell *matHeaderCellDef class="f-s-14 f-w-600">
                            Net income/(expenditure) as previously stated <br> Adjustments
                          </th>
                          <td mat-cell *matCellDef="let element">
                            <button mat-flat-button color="primary" style="height: 30px;">
                              <div class="d-flex align-items-center">
                                <i-tabler class="icon-18 m-r-10" name="plus"></i-tabler><span class="hidemenutext"> Add </span>
                              </div>
                            </button>
                          </td>
                          <!--<td mat-footer-cell *matFooterCellDef class="f-w-600">
                      Previous period net income/(expenditure) as
                      restated
                    </td>-->
                        </ng-container>

                        <ng-container matColumnDef="End of period">
                          <th mat-header-cell *matHeaderCellDef class="f-s-14 f-w-600 text-center">
                            End of period <br> &pound;
                          </th>
                          <td mat-cell *matCellDef="let element" class="f-s-14">
                          </td>
                          <!--<td mat-footer-cell *matFooterCellDef class="f-w-600">
                    </td>-->
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns2"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns2"></tr>
                        <!--<tr mat-footer-row *matFooterRowDef="displayedColumns2"></tr>-->

                      </table>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">

                <div class="row p-16 p-t-0">

                  <div class="col-sm-12 col-md-4">
                    <button mat-flat-button color="primary" class="bg-warning text-end" (click)="backToSelectNotes()">
                      <div class="d-flex text-black">
                        <i-tabler class="icon-20 m-r-4 m-t-0 " name="arrow-left"></i-tabler><span class="f-s-12 text-black"> Back</span>
                      </div>
                    </button>
                  </div>
                  <div class="col-sm-12 col-md-8" align="right">
                    <button mat-flat-button color="primary" class="bgwhite border-light b-1 text-end m-r-10">
                      <div class="d-flex text-black">
                        <i-tabler class="icon-20 m-r-4 m-t-0 text-dark" name="device-floppy"></i-tabler><span class="f-s-14 text-dark"> Save as Draft</span>
                      </div>
                    </button>
                    <button mat-flat-button color="primary" class="bg-success rounded-5" (click)="SaveAndNext()">
                      <div class="d-flex text-black">
                        <i-tabler class="icon-20 m-r-4 m-t-0 text-white" name="arrow-right"></i-tabler><span class="f-s-14 text-white"> Save &amp; Next</span>
                      </div>
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card *ngIf="note8">
          <mat-card-content class="p-0">
            <div class="p-y-16 p-x-20 b-b-1" style="background: #d9eaf0; border-radius: 10px 10px 0px 0px;">
              <div class="d-flex justify-content-between align-items-center">
                <div class="titles">
                  <h4 class="m-t-10 f-s-16 f-w-600">Note 2: Accounting Policies</h4>
                </div>
              </div>
            </div>
            <div class="p-y-16 p-x-24" style="max-height: 650px; overflow-y: scroll; margin-bottom: 30px;">
              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Recognition of income
                  </h4>
                  <button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                  <textarea matInput rows="5" value="" class="text-start" formControlName="Recognitionofincome"></textarea>
                </mat-form-field>
              </div>

              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Offsetting
                  </h4>
                  <button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                  <textarea matInput rows="5" value="" class="text-start" formControlName="Offsetting"></textarea>
                </mat-form-field>
              </div>

              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Grants and donations
                  </h4>
                  <button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                  <textarea matInput rows="5" value="" class="text-start" formControlName="Grantsanddonations"></textarea>
                </mat-form-field>
              </div>

              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Legacies
                  </h4>
                  <button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                  <textarea matInput rows="5" value="" class="text-start" formControlName="Legacies"></textarea>
                </mat-form-field>
              </div>

              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Government grants
                  </h4>
                  <button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                  <textarea matInput rows="5" value="" class="text-start" formControlName="Governmentgrants"></textarea>
                </mat-form-field>
              </div>

              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Tax reclaims on donations and gifts
                  </h4>
                  <button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                  <textarea matInput rows="5" value="" class="text-start" formControlName="Taxreclaimsondonationsandgifts"></textarea>
                </mat-form-field>
              </div>

              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Contractual income and performance related grants
                  </h4>
                  <button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                  <textarea matInput rows="5" value="" class="text-start" formControlName="incomeandperformancerelatedgrants"></textarea>
                </mat-form-field>
              </div>

              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Donated goods
                  </h4>
                  <button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                  <textarea matInput rows="10" value="" class="text-start" formControlName="Donatedgoods"></textarea>
                </mat-form-field>
              </div>

              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Donated services and facilities
                  </h4>
                  <button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                  <textarea matInput rows="10" value="" class="text-start" formControlName="Donatedservicesandfacilities"></textarea>
                </mat-form-field>
              </div>

              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Support costs
                  </h4>
                  <button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                  <textarea matInput rows="10" value="" class="text-start" formControlName="Supportcosts"></textarea>
                </mat-form-field>
              </div>

              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Volunteer help
                  </h4>
                  <button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                  <textarea matInput rows="10" value="" class="text-start" formControlName="Volunteerhelp"></textarea>
                </mat-form-field>
              </div>

              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Income from interest, royalties and dividends
                  </h4>
                  <button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                  <textarea matInput rows="10" value="" class="text-start" formControlName="Incomefrominterestroyaltiesanddividends"></textarea>
                </mat-form-field>
              </div>

              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Income from membership subscriptions
                  </h4>
                  <button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                  <textarea matInput rows="10" value="" class="text-start" formControlName="Incomefrommembershipsubscriptions"></textarea>
                </mat-form-field>
              </div>

              <!--<div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
          <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
            <h4 class="f-s-15 f-w-600">
              Income from membership subscriptions
            </h4>
            <button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
              <span class=""> Default Statement </span>
            </button>
          </div>
          <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
            <textarea matInput rows="10" value="" class="text-start" formControlName="Settlementofinsuranceclaims">Membership subscriptions received in the nature of a gift are recognised in Donations and Legacies. Membership subscriptions which gives a member the right to buy services or other benefits are recognised as income earned from the provision of goods and services as income from charitable activities.</textarea>
          </mat-form-field>
        </div>-->

              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Settlement of insurance claims
                  </h4>
                  <button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                  <textarea matInput rows="10" value="" class="text-start" formControlName="Settlementofinsuranceclaims"></textarea>
                </mat-form-field>
              </div>

              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Investment gains and losses
                  </h4>
                  <button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                  <textarea matInput rows="10" value="" class="text-start" formControlName="Investmentgainsandlosses"></textarea>
                </mat-form-field>
              </div>

            </div>
            <div class="row">
              <div class="col-lg-12">

                <div class="row p-16 p-t-0">

                  <div class="col-sm-12 col-md-4">
                    <button mat-flat-button color="primary" class="bg-warning text-end" (click)="backToSelectNotes()">
                      <div class="d-flex text-black">
                        <i-tabler class="icon-20 m-r-4 m-t-0 " name="arrow-left"></i-tabler><span class="f-s-12 text-black"> Back</span>
                      </div>
                    </button>
                  </div>
                  <div class="col-sm-12 col-md-8" align="right">
                    <button mat-flat-button color="primary" class="bgwhite border-light b-1 text-end m-r-10">
                      <div class="d-flex text-black">
                        <i-tabler class="icon-20 m-r-4 m-t-0 text-dark" name="device-floppy"></i-tabler><span class="f-s-14 text-dark"> Save as Draft</span>
                      </div>
                    </button>
                    <button mat-flat-button color="primary" class="bg-success rounded-5" (click)="SaveAndNext()">
                      <div class="d-flex text-black">
                        <i-tabler class="icon-20 m-r-4 m-t-0 text-white" name="arrow-right"></i-tabler><span class="f-s-14 text-white"> Save &amp; Next</span>
                      </div>
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card *ngIf="note9">
          <mat-card-content class="p-0">
            <div class="p-y-16 p-x-20 b-b-1" style="background: #d9eaf0; border-radius: 10px 10px 0px 0px;">
              <div class="d-flex justify-content-between align-items-center">
                <div class="titles">
                  <h4 class="m-t-10 f-s-16 f-w-600">Note 2: Accounting Policies</h4>
                </div>
              </div>
            </div>
            <div class="p-y-16 p-x-24" style="max-height: 650px; overflow-y: scroll; margin-bottom: 30px;">

              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Liability recognition
                  </h4>
                  <button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                  <textarea matInput rows="5" value="" class="text-start" formControlName="Liabilityrecognition"></textarea>
                </mat-form-field>
              </div>

              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Governance and support costs
                  </h4>
                  <button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                  <textarea matInput rows="7" value="" class="text-start" formControlName="Governanceandsupportcosts"></textarea>
                </mat-form-field>
              </div>

              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Grants with performance conditions
                  </h4>
                  <button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                  <textarea matInput rows="7" value="" class="text-start" formControlName="Grantswithperformanceconditions"></textarea>
                </mat-form-field>
              </div>

              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Grants payable without performance conditions
                  </h4>
                  <button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                  <textarea matInput rows="7" value="" class="text-start" formControlName="Grantspayablewithoutperformanceconditions"></textarea>
                </mat-form-field>
              </div>

              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Redundancy cost
                  </h4>
                  <button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                  <textarea matInput rows="3" value="" class="text-start" formControlName="Redundancycost"></textarea>
                </mat-form-field>
              </div>

              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Deferred income
                  </h4>
                  <button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                  <textarea matInput rows="3" value="" class="text-start" formControlName="Deferredincome"></textarea>
                </mat-form-field>
              </div>

              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Creditors
                  </h4>
                  <button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                  <textarea matInput rows="3" value="" class="text-start" formControlName="Creditors"></textarea>
                </mat-form-field>
              </div>

              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Provisions for liabilities
                  </h4>
                  <button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                  <textarea matInput rows="5" value="" class="text-start" formControlName="Provisionsforliabilities"></textarea>
                </mat-form-field>
              </div>

              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Basic financial instruments
                  </h4>
                  <button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                  <textarea matInput rows="5" value="" class="text-start" formControlName="Basicfinancialinstruments"></textarea>
                </mat-form-field>
              </div>

            </div>
            <div class="row">
              <div class="col-lg-12">

                <div class="row p-16 p-t-0">

                  <div class="col-sm-12 col-md-4">
                    <button mat-flat-button color="primary" class="bg-warning text-end" (click)="backToSelectNotes()">
                      <div class="d-flex text-black">
                        <i-tabler class="icon-20 m-r-4 m-t-0 " name="arrow-left"></i-tabler><span class="f-s-12 text-black"> Back</span>
                      </div>
                    </button>
                  </div>
                  <div class="col-sm-12 col-md-8" align="right">
                    <button mat-flat-button color="primary" class="bgwhite border-light b-1 text-end m-r-10">
                      <div class="d-flex text-black">
                        <i-tabler class="icon-20 m-r-4 m-t-0 text-dark" name="device-floppy"></i-tabler><span class="f-s-14 text-dark"> Save as Draft</span>
                      </div>
                    </button>
                    <button mat-flat-button color="primary" class="bg-success rounded-5" (click)="SaveAndNext()">
                      <div class="d-flex text-black">
                        <i-tabler class="icon-20 m-r-4 m-t-0 text-white" name="arrow-right"></i-tabler><span class="f-s-14 text-white"> Save &amp; Next</span>
                      </div>
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card *ngIf="note10">
          <mat-card-content class="p-0">
            <div class="p-y-16 p-x-20 b-b-1" style="background: #d9eaf0; border-radius: 10px 10px 0px 0px;">
              <div class="d-flex justify-content-between align-items-center">
                <div class="titles">
                  <h4 class="m-t-10 f-s-16 f-w-600">Note 2: Accounting Policies</h4>
                </div>
              </div>
            </div>
            <div class="p-y-16 p-x-24" style="max-height: 650px; overflow-y: scroll; margin-bottom: 30px;">
              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Tangible fixed assets for use by charity
                  </h4>
                  <!--<button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
              <span class=""> Default Statement </span>
            </button>-->
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-8" appearance="outline">
                  <textarea matInput rows="3" value="" class="text-start" formControlName="Tangiblefixedassets"></textarea>
                </mat-form-field>

                <mat-card class="cardWithShadow m-t-0 m-x-10" style="border-radius: 10px;">
                  <mat-card-content class="p-0">
                    <div class="table-responsive" style="border-radius: 10px;">
                      <table mat-table [dataSource]="assetsTangible" class="w-100">
                        <ng-container matColumnDef="Name">
                          <th mat-header-cell *matHeaderCellDef class="f-s-14 f-w-600">
                            Name
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left">
                            <mat-form-field appearance="outline" class="bg-white w-100" color="primary">
                              <input matInput class="text-left" formControlName="" />
                            </mat-form-field>
                          </td>
                          <!--<td mat-footer-cell *matFooterCellDef class="p-l-0 f-w-600">Fund balance as restated</td>-->
                        </ng-container>

                        <ng-container matColumnDef="Rate">
                          <th mat-header-cell *matHeaderCellDef class="f-s-14 f-w-600 text-right">
                            Rate (%)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-right">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" formControlName="" />
                            </mat-form-field>
                          </td>
                          <!--<td mat-footer-cell *matFooterCellDef class="p-l-0 f-w-600"></td>-->
                        </ng-container>

                        <ng-container matColumnDef="Action">
                          <th mat-header-cell *matHeaderCellDef class="f-s-14 f-w-600 text-center">
                            Action
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-center">
                            <button mat-flat-button color="primary" class="bg-none text-center" style="height: 30px;">
                              <i-tabler class="icon-18 m-r-10 text-danger" name="trash"></i-tabler>
                            </button>
                          </td>
                          <!--<td mat-footer-cell *matFooterCellDef class="p-l-0 f-w-600"></td>-->
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns3" style="background: aliceblue !important;"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns3"></tr>
                        <!--<tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>-->

                      </table>
                    </div>
                    <button mat-flat-button color="primary" class="m-l-20 m-b-10" style="height: 30px;">
                      <div class="d-flex align-items-center">
                        <i-tabler class="icon-18 m-r-10" name="plus"></i-tabler><span class="hidemenutext"> Add </span>
                      </div>
                    </button>
                  </mat-card-content>
                </mat-card>
              </div>

              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Intangible fixed assets
                  </h4>
                  <!--<button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
              <span class=""> Default Statement </span>
            </button>-->
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-8" appearance="outline">
                  <textarea matInput rows="3" value="" class="text-start" formControlName="Intangiblefixedassets"></textarea>
                </mat-form-field>

                <mat-card class="cardWithShadow m-t-0 m-x-10" style="border-radius: 10px;">
                  <mat-card-content class="p-0">
                    <div class="table-responsive" style="border-radius: 10px;">
                      <table mat-table [dataSource]="assetsInTangible" class="w-100">
                        <ng-container matColumnDef="Name">
                          <th mat-header-cell *matHeaderCellDef class="f-s-14 f-w-600">
                            Name
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left">
                            <mat-form-field appearance="outline" class="bg-white w-100" color="primary">
                              <input matInput class="text-left" formControlName="" />
                            </mat-form-field>
                          </td>
                          <!--<td mat-footer-cell *matFooterCellDef class="p-l-0 f-w-600">Fund balance as restated</td>-->
                        </ng-container>

                        <ng-container matColumnDef="Rate">
                          <th mat-header-cell *matHeaderCellDef class="f-s-14 f-w-600 text-right">
                            Rate (%)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-right">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" formControlName="" />
                            </mat-form-field>
                          </td>
                          <!--<td mat-footer-cell *matFooterCellDef class="p-l-0 f-w-600"></td>-->
                        </ng-container>

                        <ng-container matColumnDef="Action">
                          <th mat-header-cell *matHeaderCellDef class="f-s-14 f-w-600 text-center">
                            Action
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-center">
                            <button mat-flat-button color="primary" class="bg-none text-center" style="height: 30px;">
                              <i-tabler class="icon-18 m-r-10 text-danger" name="trash"></i-tabler>
                            </button>
                          </td>
                          <!--<td mat-footer-cell *matFooterCellDef class="p-l-0 f-w-600"></td>-->
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns4" style="background: aliceblue !important;"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns4"></tr>
                        <!--<tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>-->

                      </table>
                    </div>
                    <button mat-flat-button color="primary" class="m-l-20 m-b-10" style="height: 30px;">
                      <div class="d-flex align-items-center">
                        <i-tabler class="icon-18 m-r-10" name="plus"></i-tabler><span class="hidemenutext"> Add </span>
                      </div>
                    </button>
                  </mat-card-content>
                </mat-card>
              </div>

              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Heritage assets
                  </h4>
                  <button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-8" appearance="outline">
                  <textarea matInput rows="4" value="" class="text-start" formControlName="Heritageassets"></textarea>
                </mat-form-field>
              </div>

              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Investments
                  </h4>
                  <button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-8" appearance="outline">
                  <textarea matInput rows="6" value="" class="text-start" formControlName="Investments"></textarea>
                </mat-form-field>
              </div>

              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Stocks and work in progress
                  </h4>
                  <button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-8" appearance="outline">
                  <textarea matInput rows="6" value="" class="text-start" formControlName="Stocksandworkinprogress"></textarea>
                </mat-form-field>
              </div>

              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Debtors
                  </h4>
                  <button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-8" appearance="outline">
                  <textarea matInput rows="6" value="" class="text-start" formControlName="Debtors"></textarea>
                </mat-form-field>
              </div>

              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Current asset investments
                  </h4>
                  <button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-8" appearance="outline">
                  <textarea matInput rows="6" value="" class="text-start" formControlName="Currentassetinvestments"></textarea>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">

                <div class="row p-16 p-t-0">

                  <div class="col-sm-12 col-md-4">
                    <button mat-flat-button color="primary" class="bg-warning text-end" (click)="backToSelectNotes()">
                      <div class="d-flex text-black">
                        <i-tabler class="icon-20 m-r-4 m-t-0 " name="arrow-left"></i-tabler><span class="f-s-12 text-black"> Back</span>
                      </div>
                    </button>
                  </div>
                  <div class="col-sm-12 col-md-8" align="right">
                    <button mat-flat-button color="primary" class="bgwhite border-light b-1 text-end m-r-10">
                      <div class="d-flex text-black">
                        <i-tabler class="icon-20 m-r-4 m-t-0 text-dark" name="device-floppy"></i-tabler><span class="f-s-14 text-dark"> Save as Draft</span>
                      </div>
                    </button>
                    <button mat-flat-button color="primary" class="bg-success rounded-5" (click)="SaveAndNext()">
                      <div class="d-flex text-black">
                        <i-tabler class="icon-20 m-r-4 m-t-0 text-white" name="arrow-right"></i-tabler><span class="f-s-14 text-white"> Save &amp; Next</span>
                      </div>
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card *ngIf="note11">
          <mat-card-content class="p-0">
            <div class="p-y-16 p-x-20 b-b-1" style="background: #d9eaf0; border-radius: 10px 10px 0px 0px;">
              <div class="d-flex justify-content-between align-items-center">
                <div class="titles">
                  <h4 class="m-t-10 f-s-16 f-w-600">Note 3: Analysis of Income</h4>
                </div>
              </div>
            </div>
            <app-note3 selectedNoteFromParent="note11/isActive11" (childClicked)="handleChildClick($event)"></app-note3>
          </mat-card-content>
        </mat-card>
        <mat-card *ngIf="note12">
          <mat-card-content class="p-0">
            <div class="p-y-16 p-x-20 b-b-1" style="background: #d9eaf0; border-radius: 10px 10px 0px 0px;">
              <div class="d-flex justify-content-between align-items-center">
                <div class="titles">
                  <h4 class="m-t-10 f-s-16 f-w-600">Note 3: Analysis of Income</h4>
                </div>
              </div>
            </div>
            <div class="p-y-16 p-x-24" style="max-height: 750px; overflow-y: auto;">
              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Charitable activities
                  </h4>
                </div>
                <app-note3 selectedNoteFromParent="note12/isActive12" (childClicked)="handleChildClick($event)"></app-note3>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card *ngIf="note13">
          <div class="p-y-16 p-x-20 b-b-1" style="background: #d9eaf0; border-radius: 10px 10px 0px 0px;">
            <div class="d-flex justify-content-between align-items-center">
              <div class="titles">
                <h4 class="m-t-10 f-s-16 f-w-600">Note 3: Analysis of Income</h4>
              </div>
            </div>
          </div>
          <app-note3 selectedNoteFromParent="note13/isActive13" (childClicked)="handleChildClick($event)"></app-note3>
        </mat-card>
        <mat-card *ngIf="note14">
          <div class="p-y-16 p-x-20 b-b-1" style="background: #d9eaf0; border-radius: 10px 10px 0px 0px;">
            <div class="d-flex justify-content-between align-items-center">
              <div class="titles">
                <h4 class="m-t-10 f-s-16 f-w-600">Note 3: Analysis of Income</h4>
              </div>
            </div>
          </div>
          <app-note3 selectedNoteFromParent="note14/isActive14" (childClicked)="handleChildClick($event)"></app-note3>
        </mat-card>
        <mat-card *ngIf="note15">
          <div class="p-y-16 p-x-20 b-b-1" style="background: #d9eaf0; border-radius: 10px 10px 0px 0px;">
            <div class="d-flex justify-content-between align-items-center">
              <div class="titles">
                <h4 class="m-t-10 f-s-16 f-w-600">Note 3: Analysis of Income</h4>
              </div>
            </div>
          </div>
          <app-note3 selectedNoteFromParent="note15/isActive15" (childClicked)="handleChildClick($event)"></app-note3>
        </mat-card>
        <mat-card *ngIf="note16">
          <div class="p-y-16 p-x-20 b-b-1" style="background: #d9eaf0; border-radius: 10px 10px 0px 0px;">
            <div class="d-flex justify-content-between align-items-center">
              <div class="titles">
                <h4 class="m-t-10 f-s-16 f-w-600">Note 3: Analysis of Income</h4>
              </div>
            </div>
          </div>
          <app-note3 selectedNoteFromParent="note16/isActive16" (childClicked)="handleChildClick($event)"></app-note3>
        </mat-card>
        <mat-card *ngIf="note17">
          <div class="p-y-16 p-x-20 b-b-1" style="background: #d9eaf0; border-radius: 10px 10px 0px 0px;">
            <div class="d-flex justify-content-between align-items-center">
              <div class="titles">
                <h4 class="m-t-10 f-s-16 f-w-600">Note 3: Analysis of Income</h4>
              </div>
            </div>
          </div>
          <app-note3 selectedNoteFromParent="note17/isActive17" (childClicked)="handleChildClick($event)"></app-note3>
        </mat-card>
        <mat-card *ngIf="note18">
          <div class="p-y-16 p-x-20 b-b-1" style="background: #d9eaf0; border-radius: 10px 10px 0px 0px;">
            <div class="d-flex justify-content-between align-items-center">
              <div class="titles">
                <h4 class="m-t-10 f-s-16 f-w-600">Note 4: Analysis of Receipts of Government Grants</h4>
              </div>
            </div>
          </div>
          <app-note4 selectedNoteFromParent="note18/isActive18" (childClicked)="handleChildClick($event)"></app-note4>
        </mat-card>
        <mat-card *ngIf="note19">
          <div class="p-y-16 p-x-20 b-b-1" style="background: #d9eaf0; border-radius: 10px 10px 0px 0px;">
            <div class="d-flex justify-content-between align-items-center">
              <div class="titles">
                <h4 class="m-t-10 f-s-16 f-w-600">Note 5: Donated goods, facilities and services</h4>
              </div>
            </div>
          </div>
          <app-note4 selectedNoteFromParent="note19/isActive19" (childClicked)="handleChildClick($event)"></app-note4>
        </mat-card>
        <mat-card *ngIf="note20">
          <div class="p-y-16 p-x-20 b-b-1" style="background: #d9eaf0; border-radius: 10px 10px 0px 0px;">
            <div class="d-flex justify-content-between align-items-center">
              <div class="titles">
                <h4 class="m-t-10 f-s-16 f-w-600">Note 6: Expenditure Analysis</h4>
              </div>
            </div>
          </div>
          <app-note6 selectedNoteFromParent="note20/isActive20" (childClicked)="handleChildClick($event)"></app-note6>
        </mat-card>
        <mat-card *ngIf="note21">
          <div class="p-y-16 p-x-20 b-b-1" style="background: #d9eaf0; border-radius: 10px 10px 0px 0px;">
            <div class="d-flex justify-content-between align-items-center">
              <div class="titles">
                <h4 class="m-t-10 f-s-16 f-w-600">Note 6: Expenditure Analysis</h4>
              </div>
            </div>
          </div>
          <app-note6 selectedNoteFromParent="note21/isActive21" (childClicked)="handleChildClick($event)"></app-note6>
        </mat-card>
        <mat-card *ngIf="note22">
          <div class="p-y-16 p-x-20 b-b-1" style="background: #d9eaf0; border-radius: 10px 10px 0px 0px;">
            <div class="d-flex justify-content-between align-items-center">
              <div class="titles">
                <h4 class="m-t-10 f-s-16 f-w-600">Note 6: Expenditure Analysis</h4>
              </div>
            </div>
          </div>
          <app-note6 selectedNoteFromParent="note22/isActive22" (childClicked)="handleChildClick($event)"></app-note6>
        </mat-card>
        <mat-card *ngIf="note23">
          <div class="p-y-16 p-x-20 b-b-1" style="background: #d9eaf0; border-radius: 10px 10px 0px 0px;">
            <div class="d-flex justify-content-between align-items-center">
              <div class="titles">
                <h4 class="m-t-10 f-s-16 f-w-600">Note 6: Expenditure Analysis</h4>
              </div>
            </div>
          </div>
          <app-note6 selectedNoteFromParent="note23/isActive23" (childClicked)="handleChildClick($event)"></app-note6>
        </mat-card>
        <mat-card *ngIf="note24">
          <div class="p-y-16 p-x-20 b-b-1" style="background: #d9eaf0; border-radius: 10px 10px 0px 0px;">
            <div class="d-flex justify-content-between align-items-center">
              <div class="titles">
                <h4 class="m-t-10 f-s-16 f-w-600">Note 7: Extraordinary Items</h4>
              </div>
            </div>
          </div>
          <app-note7 selectedNoteFromParent="note24/isActive24" (childClicked)="handleChildClick($event)"></app-note7>
        </mat-card>
        <mat-card *ngIf="note25">
          <div class="p-y-16 p-x-20 b-b-1" style="background: #d9eaf0; border-radius: 10px 10px 0px 0px;">
            <div class="d-flex justify-content-between align-items-center">
              <div class="titles">
                <h4 class="m-t-10 f-s-16 f-w-600">Note 8: Funds received as agent</h4>
              </div>
            </div>
          </div>
          <app-note7 selectedNoteFromParent="note25/isActive25" (childClicked)="handleChildClick($event)"></app-note7>
        </mat-card>
        <mat-card *ngIf="note26">
          <div class="p-y-16 p-x-20 b-b-1" style="background: #d9eaf0; border-radius: 10px 10px 0px 0px;">
            <div class="d-flex justify-content-between align-items-center">
              <div class="titles">
                <h4 class="m-t-10 f-s-16 f-w-600">Note 8: Funds received as agent</h4>
              </div>
            </div>
          </div>
          <app-note7 selectedNoteFromParent="note26/isActive26" (childClicked)="handleChildClick($event)"></app-note7>
        </mat-card>
        <mat-card *ngIf="note27">
          <div class="p-y-16 p-x-20 b-b-1" style="background: #d9eaf0; border-radius: 10px 10px 0px 0px;">
            <div class="d-flex justify-content-between align-items-center">
              <div class="titles">
                <h4 class="m-t-10 f-s-16 f-w-600">Note 9: Support Costs</h4>
              </div>
            </div>
          </div>
          <app-note7 selectedNoteFromParent="note27/isActive27" (childClicked)="handleChildClick($event)"></app-note7>
        </mat-card>
        <mat-card *ngIf="note28">
          <div class="p-y-16 p-x-20 b-b-1" style="background: #d9eaf0; border-radius: 10px 10px 0px 0px;">
            <div class="d-flex justify-content-between align-items-center">
              <div class="titles">
                <h4 class="m-t-10 f-s-16 f-w-600">Note 10: Details of certain types of expenditure</h4>
              </div>
            </div>
          </div>
          <app-note7 selectedNoteFromParent="note28/isActive28" (childClicked)="handleChildClick($event)"></app-note7>
        </mat-card>
        <mat-card *ngIf="note29">
          <div class="p-y-16 p-x-20 b-b-1" style="background: #d9eaf0; border-radius: 10px 10px 0px 0px;">
            <div class="d-flex justify-content-between align-items-center">
              <div class="titles">
                <h4 class="m-t-10 f-s-16 f-w-600">Note 11: Paid Employees</h4>
              </div>
            </div>
          </div>
          <app-note7 selectedNoteFromParent="note29/isActive29" (childClicked)="handleChildClick($event)"></app-note7>
        </mat-card>
        <mat-card *ngIf="note30">
          <div class="p-y-16 p-x-20 b-b-1" style="background: #d9eaf0; border-radius: 10px 10px 0px 0px;">
            <div class="d-flex justify-content-between align-items-center">
              <div class="titles">
                <h4 class="m-t-10 f-s-16 f-w-600">Note 11: Paid Employees</h4>
              </div>
            </div>
          </div>
          <app-note7 selectedNoteFromParent="note30/isActive30" (childClicked)="handleChildClick($event)"></app-note7>
        </mat-card>
        <mat-card *ngIf="note31">
          <div class="p-y-16 p-x-20 b-b-1" style="background: #d9eaf0; border-radius: 10px 10px 0px 0px;">
            <div class="d-flex justify-content-between align-items-center">
              <div class="titles">
                <h4 class="m-t-10 f-s-16 f-w-600">Note 11: Paid Employees</h4>
              </div>
            </div>
          </div>
          <app-note7 selectedNoteFromParent="note31/isActive31" (childClicked)="handleChildClick($event)"></app-note7>
        </mat-card>
        <mat-card *ngIf="note32">
          <div class="p-y-16 p-x-20 b-b-1" style="background: #d9eaf0; border-radius: 10px 10px 0px 0px;">
            <div class="d-flex justify-content-between align-items-center">
              <div class="titles">
                <h4 class="m-t-10 f-s-16 f-w-600">Note 11: Paid Employees</h4>
              </div>
            </div>
          </div>
          <app-note7 selectedNoteFromParent="note32/isActive32" (childClicked)="handleChildClick($event)"></app-note7>
        </mat-card>
        <mat-card *ngIf="note33">
          <div class="p-y-16 p-x-20 b-b-1" style="background: #d9eaf0; border-radius: 10px 10px 0px 0px;">
            <div class="d-flex justify-content-between align-items-center">
              <div class="titles">
                <h4 class="m-t-10 f-s-16 f-w-600">Note 12: Pension Schemes</h4>
              </div>
            </div>
          </div>
          <app-note7 selectedNoteFromParent="note33/isActive33" (childClicked)="handleChildClick($event)"></app-note7>
        </mat-card>
        <mat-card *ngIf="note34">
          <div class="p-y-16 p-x-20 b-b-1" style="background: #d9eaf0; border-radius: 10px 10px 0px 0px;">
            <div class="d-flex justify-content-between align-items-center">
              <div class="titles">
                <h4 class="m-t-10 f-s-16 f-w-600">Note 12: Pension Schemes</h4>
              </div>
            </div>
          </div>
          <app-note7 selectedNoteFromParent="note34/isActive34" (childClicked)="handleChildClick($event)"></app-note7>
        </mat-card>
        <mat-card *ngIf="note35">
          <div class="p-y-16 p-x-20 b-b-1" style="background: #d9eaf0; border-radius: 10px 10px 0px 0px;">
            <div class="d-flex justify-content-between align-items-center">
              <div class="titles">
                <h4 class="m-t-10 f-s-16 f-w-600">Note 12: Pension Schemes</h4>
              </div>
            </div>
          </div>
          <app-note7 selectedNoteFromParent="note35/isActive35" (childClicked)="handleChildClick($event)"></app-note7>
        </mat-card>
      </div>
    </div>
    

  </div>
</div>
